<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="widget">
          <div class="form-elements-sec">
            <div class="widget-title">
              <h3>
                Haber Düzenle
                <small>( {{ title }} )</small>
              </h3>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="title">Başlık</label>
                  <input type="text" v-model="title" class="form-control custom-input">
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="slug">SEF Link</label>
                  <input type="text" v-model="slug" class="form-control custom-input">
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="description">Kısa Açıklama</label>
                  <input type="text" v-model="description" class="form-control custom-input">
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="content">İçerik</label>
                  <vue-editor :editorToolbar="customToolbar" v-model="content" class="editor"></vue-editor>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for></label>
                  <button class="btn btn-success pull-right" @click="updateData">Kaydet</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { VueEditor } from "vue2-editor";

export default {
  components: { VueEditor },
  data() {
    return {
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }]
      ],
        id: this.$route.params.id,
      title: "",
      slug: "",
      description: "",
      content: "",
      api: "news/"
    };
  },
  mounted() {
      this.getData()
  },
  methods: {
      getData() {
            this.$Progress.start()
            this.axios.get(this.api + this.id + '/edit').then(response => {
                this.title = response.data.title
                this.slug = response.data.slug
                this.description = response.data.description
                this.content = response.data.content
                this.$Progress.finish()
            })
        },
        updateData() {
                this.$Progress.start()
                this.axios.put(this.api + this.id, {
                    title: this.title,
                    slug: this.slug,
                    description: this.description,
                    content: this.content
                }).then(response => {
                    this.$Progress.finish()
                })
            }
  },
};
</script>

<style scoped>
</style>
